import { render } from "./BaseCard.vue?vue&type=template&id=3c53b486"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=3c53b486&lang=css"

import exportComponent from "C:\\Users\\THULIB\\Documents\\GitHub\\Coach-Finder-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__